import useCurrency from '@/hooks/use-currency'
import {useLocale} from '@helios/shared/providers/locale'

export const useCurrencyFormat = () => {
    const currentLocale = useLocale()
    const currency = useCurrency()

    return new Intl.NumberFormat(currentLocale.code, {
        style: 'currency',
        currency: currency.code,
        currencyDisplay: 'symbol',
    })
}
